"use client";

import { c as _c } from "react-compiler-runtime";
import type { ReactNode } from "react";
import LoadableProcessingImage from "./LoadableProcessingImage";
type ProcessingImageFrameProps = {
  variant: "square" | "portrait";
  src?: string;
  alt: string;
  children?: ReactNode;
};
export default function ProcessingImageFrame(t0) {
  const $ = _c(9);
  const {
    variant,
    src,
    alt,
    children
  } = t0;
  const frameClassName = variant === "square" ? "relative h-48 w-48 overflow-hidden rounded-2xl shadow-xl ring-2 ring-primary/20 sm:h-56 sm:w-56" : "relative h-64 w-48 overflow-hidden rounded-2xl shadow-lg ring-1 ring-primary/10";
  const shouldContainImage = variant === "portrait";
  const imageClassName = shouldContainImage ? "object-contain object-center" : "object-cover";
  const t1 = shouldContainImage ? "absolute inset-0 h-full w-full scale-110 object-cover opacity-40 blur-xl" : undefined;
  const t2 = `absolute inset-0 h-full w-full ${imageClassName}`;
  let t3;
  if ($[0] !== alt || $[1] !== src || $[2] !== t1 || $[3] !== t2) {
    t3 = <LoadableProcessingImage alt={alt} backdropClassName={t1} imageClassName={t2} skeletonClassName="h-full w-full rounded-2xl" src={src} />;
    $[0] = alt;
    $[1] = src;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== frameClassName || $[7] !== t3) {
    t4 = <div className={frameClassName}>{t3}{children}</div>;
    $[5] = children;
    $[6] = frameClassName;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}